export { default as DocumentPanel } from './DocumentPanel';
